@if (panels && panels.length > 0) {
  <div class="cta-panel-container">
    <div class="panel-section-container">
      @for (panel of panels; track panel) {
        <section class="panel-section">
          <h2 class="panel-name">{{ panel.panelName }}</h2>
          <div [innerHTML]="panel.description"></div>
          @if (panel.type !== 'None') {
            <div class="cta-button-container">
              @if (panel.type === 'LinkToURL') {
                <div>
                  <a
                    mat-flat-button
                    class="cta-button"
                    color="primary"
                    [href]="panel.buttonActionValue"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ panel.buttonText }}</a
                  >
                </div>
              }
              @if (panel.type === 'LinkToForm') {
                <div>
                  <button
                    mat-flat-button
                    class="cta-button"
                    color="primary"
                    [disabled]="fromRequestInProgress"
                    (click)="redirectToForm(panel.buttonActionValue)"
                  >
                    {{ panel.buttonText }}
                  </button>
                </div>
              }
            </div>
          }
        </section>
      }
    </div>
  </div>
}
